<template>
  <div>
    <div class="container" style="background-color: white; text-align: left;">
      <h5 class="detail-h5">{{salesGroup.salesGroupName}}</h5>

      <div style="margin-top: 15px;">
        <div class="row">
          <div class="col-sm-6">
            <dl class="row" style="margin-bottom: 0;">
              <dt class="col-sm-5">{{ $t('license_expired') }}</dt>
              <dd class="col-sm-4">
                <vc-date-picker
                  locale="nl-NL"
                  mode="single"
                  v-model="salesGroup.licenseExpirationDate"
                />
              </dd>

              <dt class="col-sm-5">{{ $t('en_and_or_hs') }}</dt>
              <dd class="col-sm-7">
                <b-form-checkbox v-model="salesGroup.isEndoscopy" value="true">Endoscopy</b-form-checkbox>
              </dd>

              <dt class="col-sm-5"></dt>
              <dd class="col-sm-7">
                <b-form-checkbox v-model="salesGroup.isHospitalSolutions" value="true">Hospital solutions</b-form-checkbox>
              </dd>
            </dl>
          </div>
        </div>

        <div style="max-height: 650px;">
          <h5 class="detail-h5">{{ $t('user_overview') }}</h5>

          <div class="row" style="margin: 0; padding-bottom: 0.5rem">
            <b-button size="sm" @click="addNewUserClick()">{{ $t('add_user') }}</b-button>
          </div>

          <div style="padding-top: 0.25rem; padding-bottom: 0.75rem;">
            <input
              v-model="searchLoginFilter"
              class="form-control form-control-sm"
              :placeholder="$t('search')"
              style="width: 250px;"
            />
          </div>

          <b-table-simple hover small caption-top responsive style="max-height: 411px;">
            <b-tbody>
              <b-tr v-for="login in filteredLogins" v-bind:key="login.loginKey">
                <b-td style="text-align: left; cursor: pointer; padding: 0.65rem 0.75rem;" v-on:click="rowClicked(login.loginKey)">{{login.user}}</b-td>
                <b-td style="padding: 0.3rem; width: 125px;">
                  <b-button
                    class="row-user-delete"
                    variant="danger"
                    size="sm"
                    @click="deleteLogin(login)"
                  >{{$t('delete')}}</b-button>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SalesGroupDetail',
  components: { },
  data: function() {
    return {
      salesGroup: {
        logins: [],
        licenseExpirationDate: ''
      },
      searchLoginFilter: '',
      logins: []
    };
  },
  methods: {
    rowClicked(loginKey) {
      this.$router.push({
        name: 'user-detail',
        params: {
          salesGroupId: this.salesGroup.salesGroupId,
          loginKey: loginKey
        }
      });
    },
    addNewUserClick(item, index, event) {
      this.$router.push({
        name: 'user-detail',
        params: {
          companyId: this.salesGroup.companyId,
          salesGroupId: this.salesGroup.salesGroupId,
          loginKey: -1
        }
      });
    },
    deleteLogin: function(login) {
      let promise = this.$axios.post('logins/remove', login, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      promise
        .then(data => {
          this.logins = this.logins.filter(
            item => item.loginKey !== login.loginKey
          );
        })
        .catch(error => {
          if (error.response.status === 409) {
            this.showError = true;
          }

          console.log(error.response.status);
        });
    }
  },
  watch: {
    salesGroup: {
      handler: function(val, oldVal) {
        updateSalesGroup(this, val);
      },
      deep: true
    }
  },
  computed: {
    filteredLogins() {
      return this.logins.filter(login => {
        return login.user
          .toLowerCase()
          .includes(this.searchLoginFilter.toLowerCase());
      });
    }
  },
  created() {
    // bus.$on('languageChanged', this.changeLanguageHandler);

    getSalesGroup(this, this.$route.params.salesGroupId);
  },
  beforeDestroy() {
    // bus.$off('languageChanged', this.changeLanguageHandler);
  }
};

function getSalesGroup(context, salesGroupId) {
  let promise = context.$axios.get('salesGroups?salesGroupId=' + salesGroupId);

  return promise
    .then(data => {
      const item = data.data;

      context.salesGroup = item;
      context.logins = item.logins;

      if (item.licenseExpirationDate !== null) {
        context.salesGroup.licenseExpirationDate = new Date(
          item.licenseExpirationDate
        );
      }

      context.pageTitle = item.salesGroupName;
    })
    .catch(error => {
      console.log(error);
    });
}

function updateSalesGroup(context, salesGroup) {
  let promise = context.$axios.post('salesGroups/postSalesGroup', salesGroup, {
    headers: {
      'Content-Type': 'application/json'
    }
  });

  promise
    .then(data => {
      // ignore
    })
    .catch(error => {
      if (error.response.status === 409) {
        this.showError = true;
      }

      console.log(error.response.status);
    });
}
</script>

<style>
table.b-table > thead > tr > th.sorting:focus {
  outline: none !important;
}
.page-item.active .page-link {
  background-color: #18385f;
  border-color: #18385f;
}
.page-link:focus {
  box-shadow: none;
}
</style>

<style scope>
.vc-text-base {
  font-size: 12px;
  padding: 0.25rem 0.5rem;
  height: 28px;
}

.td-user-delete {
  padding: 3px !important;
}

.row-user-delete {
  display: none;
  float: right;
  margin-right: 3px;
}

.table-hover tbody tr:hover .row-user-delete {
  display: block !important;
}
</style>
